'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _DigitalBlock = require('./components/DigitalBlock.component');

Object.defineProperty(exports, 'default', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_DigitalBlock).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }


//////////////////
// WEBPACK FOOTER
// ./~/@bibliocommons/availability-digital-block/lib/index.js
// module id = 1170
// module chunks = 0